module.exports = __webpack_public_path__ + "img/s00173.acf4cbcd.png";